import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import StartTime from "./StartTime.js";
const useStyles = makeStyles((theme) => ({}));
function Daily(props) {
  const [value, setValue] = useState(1);
  const classes = useStyles();
  const [startTime, setStartTime] = useState({ minutes: 0, hours: 0 });

  const returnValue = (value) => {
    setValue(value);
    props.returnValue(value, startTime);
  };

  const returnStartTime = (time) => {
    setStartTime(time);
    props.returnValue(value, time);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
      <div>
        <TextField
          id="outlined-number"
          label="Every day(s)"
          value={value}
          min={1}
          max={60}
          onChange={(e) =>
            e.target.value < 32 &&
            e.target.value >= 1 &&
            returnValue(e.target.value)
          }
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
        />
      </div>
      <StartTime returnValue={returnStartTime} />
    </div>
  );
}

export default Daily;
